export default "__VITE_ASSET__67dd2f31__"